import React from "react";
import ReactToPrint from "react-to-print";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import LungChart from "../Chart/LungChart";

const diplayStyle = {
  display: "hidden",
};
class PrintResult extends React.Component {
  render() {
    const {
      age,
      que1,
      que4,
      sex,
      cm,
      kg,
      total,
      fiveTotal,
      perage,
      hpyn,
      pa,
    } = this.props;
    return (
      <div>
        <Grid container alignItems="center">
          <Grid
            style={{
              fontSize: 22,
              fontWeight: 600,
              paddingTop: 12,
              paddingBottom: 12,
              paddingLeft: 24,
              marginTop: 24,
              marginBottom: 24,
            }}
          >
            전립선암 위험도 자가진단 결과 레포트
          </Grid>
        </Grid>
        <Grid
          container
          justify="center"
          direction="column"
          style={{ padding: "16px 24px" }}
        >
          <Grid container justify="center" direction="column">
            <Grid container direction="column">
              <h3 style={{ color: "#115bab", fontWeight: 700, fontSize: 20 }}>
                입력정보
              </h3>
              <Grid
                container
                justify="space-between"
                alignItems="center"
                direction="row"
                style={{ border: "1px solid #c9d9ea" }}
              >
                <Grid
                  container
                  alignItems="center"
                  justify="center"
                  direction="row"
                >
                  <Grid
                    container
                    alignItems="center"
                    justify="center"
                    style={{
                      width: "50%",
                      fontSize: 20,
                      paddingTop: 15,
                      paddingBottom: 15,
                      color: "#60768e",
                      fontWeight: 400,
                      borderBottom: "1px solid  #c9d9ea",
                      borderRight: "1px solid  #c9d9ea",
                    }}
                  >
                    기본정보
                  </Grid>
                  <Grid
                    container
                    alignItems="center"
                    justify="center"
                    style={{
                      width: "50%",
                      fontSize: 20,
                      paddingTop: 15,
                      paddingBottom: 15,
                      color: "#60768e",
                      fontWeight: 400,
                      borderBottom: "1px solid  #c9d9ea",
                      borderRight: "1px solid  #c9d9ea",
                    }}
                  >
                    생활정보
                  </Grid>
                </Grid>
                <Grid
                  container
                  alignItems="center"
                  justify="center"
                  direction="row"
                >
                  <Grid
                    container
                    alignItems="center"
                    justify="center"
                    direction="column"
                    style={{
                      width: "50%",
                      fontSize: 20,
                      paddingTop: 15,
                      paddingBottom: 15,
                      color: "#60768e",
                      fontWeight: 400,
                      borderRight: "1px solid  #c9d9ea",
                    }}
                  >
                    <Grid
                      container
                      alignItems="center"
                      justify="space-between"
                      direction="row"
                      style={{
                        paddingLeft: 36,
                        paddingRight: 36,
                        paddingTop: 11,
                        paddingBottom: 11,
                        "& .right": {
                          width: 130,
                        },
                        "& .black": {
                          color: "#333333",
                        },
                      }}
                    >
                      <Grid
                        container
                        alignItems="center"
                        justify="space-between"
                        direction="row"
                        style={{ width: 130 }}
                      >
                        <Grid>성별</Grid>
                        <Grid>
                          <span style={{ color: "#333333" }}>
                            {sex ? "남성" : "여성"}
                          </span>
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        alignItems="center"
                        justify="space-between"
                        direction="row"
                        style={{ width: 130 }}
                      >
                        <Grid>신장</Grid>
                        <Grid>
                          <span style={{ color: "#333333" }}>
                            {cm.value} cm
                          </span>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      alignItems="center"
                      justify="space-between"
                      direction="row"
                      style={{
                        paddingLeft: 36,
                        paddingRight: 36,
                        paddingTop: 11,
                        paddingBottom: 11,
                        "& .right": {
                          width: 130,
                        },
                        "& .black": {
                          color: "#333333",
                        },
                      }}
                    >
                      <Grid
                        container
                        alignItems="center"
                        justify="space-between"
                        direction="row"
                        style={{ width: 130 }}
                      >
                        <Grid>연령</Grid>
                        <Grid>
                          <span style={{ color: "#333333" }}>
                            {age.value}세
                          </span>
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        alignItems="center"
                        justify="space-between"
                        direction="row"
                        style={{ width: 130 }}
                      >
                        <Grid>체중</Grid>
                        <Grid>
                          <span style={{ color: "#333333" }}>{kg.value}kg</span>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    alignItems="center"
                    justify="center"
                    style={{
                      width: "50%",
                      fontSize: 20,
                      paddingTop: 15,
                      paddingBottom: 15,
                      color: "#60768e",
                      fontWeight: 400,
                      "& .black": {
                        color: "black",
                        fontWeight: 600,
                      },
                    }}
                  >
                    <Grid
                      container
                      alignItems="center"
                      justify="space-between"
                      direction="row"
                      style={{
                        paddingLeft: 36,
                        paddingRight: 36,
                        paddingTop: 11,
                        paddingBottom: 11,
                        "& .right": {
                          width: 130,
                        },
                        "& .black": {
                          color: "#333333",
                        },
                      }}
                    >
                      <Grid
                        container
                        alignItems="center"
                        justify="space-between"
                        direction="row"
                        style={{ width: 130 }}
                      >
                        <Grid>당뇨</Grid>
                        <Grid>
                          <span style={{ color: "#333333" }}>
                            &nbsp;{que1 ? "있음" : "없음"}
                          </span>
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        alignItems="center"
                        justify="space-between"
                        direction="row"
                        style={{ width: 130 }}
                      >
                        <Grid>고혈압</Grid>
                        <Grid>
                          <span style={{ color: "#333333" }}>
                            &nbsp;{hpyn ? "있음" : "없음"}
                          </span>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      alignItems="center"
                      justify="space-between"
                      direction="row"
                      style={{
                        paddingLeft: 36,
                        paddingRight: 36,
                        paddingTop: 11,
                        paddingBottom: 11,
                        "& .right": {
                          width: 130,
                        },
                        "& .black": {
                          color: "#333333",
                        },
                      }}
                    >
                      <Grid
                        container
                        alignItems="center"
                        justify="space-between"
                        direction="row"
                        style={{ width: 130 }}
                      >
                        <Grid>갑력(흡연)</Grid>
                        <Grid>
                          <span style={{ color: "#333333" }}>
                            &nbsp;{que4 ? "있음" : "없음"}
                          </span>
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        alignItems="center"
                        justify="space-between"
                        direction="row"
                        style={{ width: 130 }}
                      >
                        <Grid>운동여부</Grid>
                        <Grid>
                          <span style={{ color: "#333333" }}>
                            &nbsp;{pa ? "있음" : "없음"}
                          </span>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: 10 }}>
            <h3 style={{ color: "#115bab", fontWeight: 700, fontSize: 20 }}>
              절대 위험도
            </h3>
            <Grid
              container
              justify="space-between"
              alignItems="center"
              direction="row"
              style={{ border: "1px solid #c9d9ea" }}
              // className={classes.table}
            >
              <Grid
                container
                alignItems="center"
                justify="center"
                direction="row"
              >
                <Grid
                  container
                  alignItems="center"
                  justify="center"
                  style={{
                    width: "50%",
                    fontSize: 20,
                    paddingTop: 15,
                    paddingBottom: 15,
                    color: "#60768e",
                    fontWeight: 400,
                    borderBottom: "1px solid  #c9d9ea",
                    borderRight: "1px solid  #c9d9ea",
                  }}
                  // className={classes.title1}
                >
                  종합점수
                </Grid>
                <Grid
                  container
                  alignItems="center"
                  justify="center"
                  style={{
                    width: "50%",
                    paddingTop: 15,
                    paddingBottom: 15,
                    fontSize: 20,
                    color: "#60768e",
                    fontWeight: 400,
                    borderBottom: "1px solid  #c9d9ea",
                  }}
                  // className={classes.title2}
                >
                  <span
                    style={{ color: "#333333", fontWeight: 700, fontSize: 20 }}
                  >
                    {total}
                    <span style={{ fontSize: 20, fontWeight: 400 }}>
                      &nbsp;/ 220 점
                    </span>
                  </span>
                </Grid>
              </Grid>
              <Grid
                container
                alignItems="center"
                justify="center"
                direction="row"
              >
                <Grid
                  container
                  alignItems="center"
                  justify="center"
                  style={{
                    width: "50%",
                    fontSize: 20,
                    paddingTop: 15,
                    paddingBottom: 15,
                    color: "#60768e",
                    fontWeight: 400,
                  }}
                  // className={classes.contents1}
                >
                  5년 위험도
                </Grid>
                <Grid
                  container
                  alignItems="center"
                  justify="center"
                  style={{
                    width: "50%",
                    fontSize: 20,
                    paddingTop: 15,
                    paddingBottom: 15,
                    color: "#60768e",
                    fontWeight: 400,
                    "& .black": {
                      color: "black",
                      fontWeight: 600,
                    },
                    borderLeft: "1px solid  #c9d9ea",
                  }}
                >
                  <Grid
                    container
                    alignItems="center"
                    justify="space-between"
                    direction="row"
                    style={{
                      paddingLeft: 36,
                      width: 400,
                      justifyContent: "center",
                      paddingRight: 36,
                      paddingTop: 11,
                      paddingBottom: 11,
                      "& .right": {
                        width: 130,
                      },
                      "& .black": {
                        color: "#333333",
                      },
                    }}
                  >
                    <Grid>
                      1년차 생존률 :&nbsp;
                      <span style={{ color: "black" }}>{fiveTotal.y1}%</span>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    alignItems="center"
                    justify="space-between"
                    direction="row"
                    style={{
                      paddingLeft: 36,
                      width: 400,
                      justifyContent: "center",
                      paddingRight: 36,
                      paddingTop: 11,
                      paddingBottom: 11,
                      "& .right": {
                        width: 130,
                      },
                      "& .black": {
                        color: "#333333",
                      },
                    }}
                  >
                    <Grid>
                      2년차 생존률 :&nbsp;
                      <span style={{ color: "black" }}>{fiveTotal.y2}%</span>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    alignItems="center"
                    justify="space-between"
                    direction="row"
                    style={{
                      paddingLeft: 36,
                      width: 400,
                      justifyContent: "center",
                      paddingRight: 36,
                      paddingTop: 11,
                      paddingBottom: 11,
                      "& .right": {
                        width: 130,
                      },
                      "& .black": {
                        color: "#333333",
                      },
                    }}
                    // className={classes.contentsStyle2}
                  >
                    <Grid>
                      3년차 생존률 :&nbsp;
                      <span style={{ color: "black" }}>{fiveTotal.y3}%</span>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    alignItems="center"
                    justify="space-between"
                    direction="row"
                    style={{
                      paddingLeft: 36,
                      width: 400,
                      justifyContent: "center",
                      paddingRight: 36,
                      paddingTop: 11,
                      paddingBottom: 11,
                      "& .right": {
                        width: 130,
                      },
                      "& .black": {
                        color: "#333333",
                      },
                    }}
                    // className={classes.contentsStyle2}
                  >
                    <Grid>
                      4년차 생존률 :&nbsp;
                      <span style={{ color: "black" }}>{fiveTotal.y4}%</span>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    alignItems="center"
                    justify="space-between"
                    direction="row"
                    style={{
                      paddingLeft: 36,
                      width: 400,
                      justifyContent: "center",
                      paddingRight: 36,
                      paddingTop: 11,
                      paddingBottom: 11,
                      "& .right": {
                        width: 130,
                      },
                      "& .black": {
                        color: "#333333",
                      },
                    }}
                    // className={classes.contentsStyle2}
                  >
                    <Grid>
                      5년차 생존률 :&nbsp;
                      <span style={{ color: "black" }}>{fiveTotal.y5}%</span>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              style={{
                color: "#747474",
                fontSize: 14,
                paddingTop: 12,
                paddingBottom: 12,
              }}
            >
              * 점수가 높을수록 고위험군 입니다.
            </Grid>
          </Grid>
          <Grid container direction="column" style={{ marginTop: 340 }}>
            <h3 style={{ color: "#115bab", fontWeight: 700, fontSize: 20 }}>
              상대 위험도
            </h3>
            <div style={{ paddingBottom: 11, paddingLeft: 1, marginTop: 12 }}>
              발생빈도(건수)
            </div>
            <Grid style={{ width: "100%", height: "250px" }}>
              <LungChart age={age} />
            </Grid>
          </Grid>
          <Grid
            style={{
              color: "#747474",
              fontSize: 14,
              paddingTop: 12,
              paddingBottom: 12,
              marginTop: 12,
            }}
          >
            * 출처 : KOSIS 보건복지부 암등록 통계 2020년
          </Grid>
          <h3 style={{ color: "#115bab", fontWeight: 700, fontSize: 20 }}>
            결과진단
          </h3>
          <Grid style={{ fontSize: 20, fontWeight: 400, lineHeight: 1.5 }}>
            환자분의 1년이내 생존률은&nbsp;{" "}
            <span style={{ color: "#115bab" }}>{fiveTotal.y1}%</span>입니다.
            <br /> 같은 성별, 연령대의 평균 폐암 발생빈도는 10만 명 당 {perage}
            명입니다.
            <br /> 폐암 조기 검사의 이득과 손해를 알아보시고 현명한 결정 하시길
            추천합니다.
          </Grid>
        </Grid>
      </div>
    );
  }
}

class PrintButton extends React.Component {
  render() {
    const {
      age,
      total,
      que1,
      que2,
      que3,
      que4,
      sex,
      cm,
      kg,
      fiveTotal,
      perage,
    } = this.props;
    return (
      <>
        <ReactToPrint
          trigger={() => (
            <Button
              variant="contained"
              fullWidth
              color="primary"
              style={{ fontSize: 16, fontWeight: 400 }}
              // className={classes.footerButton}
            >
              출력
            </Button>
          )}
          content={() => this.componentRef}
        />
        <div style={diplayStyle}>
          <PrintResult
            age={age}
            que1={que1}
            sex={sex}
            que2={que2}
            que3={que3}
            que4={que4}
            cm={cm}
            total={total}
            fiveTotal={fiveTotal}
            kg={kg}
            perage={perage}
            ref={(el) => (this.componentRef = el)}
          />
        </div>
      </>
    );
  }
}

export default PrintButton;
